import { ExtraDustyProductsStore } from './ExtraDusyProductsStore';

export const extraDustyProductsStore = new ExtraDustyProductsStore();

export { ExtraDustyProductsStore } from './ExtraDusyProductsStore';

export interface IStandardTimeLegendStores {
  extraDustyProductsStore: ExtraDustyProductsStore;
}
